import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import type { Icon } from '@hyundai/assets';
import {
    DealerFeature,
    FootnotesPipe,
    RouterLinkDirective,
    ServicesFeature,
    toLoaded,
    TrackingDirective,
} from '@hyundai/ng-common-lib';
import { EditableDirective } from '@hyundai/ng-edit-lib';
import {
    M010C020IconLinkComponent,
    M040C020TeaserAllrounderComponent,
    M040C040PromotionBannerComponent,
    M040C050CardComponent,
    M040C130ContactBannerComponent,
} from '@hyundai/ui';
import { Store } from '@ngrx/store';
import { GlobalContactComponent } from '../../../components/global-contact/global-contact.component';

@Component({
    selector: 'app-services-page',
    standalone: true,
    templateUrl: './services-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterLinkDirective,
        M010C020IconLinkComponent,
        GlobalContactComponent,
        M040C020TeaserAllrounderComponent,
        M040C040PromotionBannerComponent,
        EditableDirective,
        M040C050CardComponent,
        FootnotesPipe,
        M040C130ContactBannerComponent,
        TrackingDirective,
    ],
})
export default class ServicesPageComponent {
    store = inject(Store);

    servicesHero = this.store.selectSignal(ServicesFeature.state.selectLoadedServicesHero);
    openings = this.store.selectSignal(DealerFeature.state.selectServicesOpening);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    dealerContactMailLink = this.store.selectSignal(DealerFeature.state.selectDealerContactFormUrl);
    generalServices = toLoaded(this.store.selectSignal(ServicesFeature.state.selectGeneralServices));
    locationHeadline = this.store.selectSignal(DealerFeature.state.selectDealerLocationHeadline);
    keyCampaign = this.store.selectSignal(DealerFeature.state.selectKeyCampaign);

    constructor() {
        this.store.dispatch(ServicesFeature.actions.loadGeneralServices());
    }

    bullets = computed(() => {
        const servicesHero = this.servicesHero();

        if (!servicesHero) return;

        const heroBulletList: Array<{ icon: Icon; text: string }> = servicesHero.bullets.map((b) => ({
            icon: 'icon-check',
            text: b.text,
        }));
        return heroBulletList;
    });

    serviceOpeningText = computed(() => {
        return this.openings()
            .ranges.map((r) => `${r.start} - ${r.end}`)
            .join(' und ');
    });

    heroImage = computed(() => ({
        image: this.servicesHero().heroImage.url,
        desktop: { width: 1000, height: 600 },
        tablet: { width: 1000, height: 560 },
        mobile: { width: 766, height: 560 },
    }));
}
